import { rootApi } from '../rootApi';

export const approvalLimitsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getApprovalLimits: builder.query({
      query: (params) => ({
        url: 'v1/approvalmanagement/getapprovallimits',
        method: 'POST',
        body: {
          pageNumber: params?.pageNumber || 1,
          pageSize: params?.pageSize || 10,
          isActive: params?.isActive ?? 1,
          approvalGroupId: params?.approvalGroupId || null,
          groupId: params?.groupId || null,
          currency: params?.currency || ""
        }
      }),
      transformResponse: (res) => ({
        items: res.data?.items || [],
        totalCount: res.data?.totalCount || 0,
        isSuccessful: res.isSuccessful || false
      }),
      providesTags: ['ApprovalLimits']
    }),
    createApprovalLimit: builder.mutation({
      query: (payload) => ({
        url: 'v1/approvalmanagement/createapprovallimit',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['ApprovalLimits']
    }),
    updateApprovalLimit: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: 'v1/approvalmanagement/updateapprovallimit',
        method: 'POST',
        body: { id, ...rest }
      }),
      invalidatesTags: ['ApprovalLimits']
    }),
    getApprovalLimitById: builder.query({
      query: (id) => ({
        url: 'v1/approvalmanagement/getapprovallimitbyid',
        method: 'GET',
        params: { id }
      }),
      transformResponse: (res) => res.data,
      providesTags: ['ApprovalLimits']
    }),

  })
});

export const {
  useGetApprovalLimitsQuery,
  useGetApprovalLimitByIdQuery,
  useCreateApprovalLimitMutation,
  useUpdateApprovalLimitMutation
} = approvalLimitsApi; 